import { css } from '@inter-ikea-kompis/web-component';

export default class SortListStyle {
	public static getStyle(): string {
		return css`
			:host {
				display: inline-block;
				line-height: 0;
			}
			.container {
				position: relative;
				display: block;
			}
		`;
	}
}
